import styled from "styled-components";

export const Border = styled.div`
  height: 90vh;
  width: 5vw;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 30px;
  z-index: 3;

  @media (max-width: 768px) {
    height: auto;
    flex-direction: row;
    width: 100%;
    justify-content: space-evenly;
    padding: 5px 0;
    position: fixed;
    bottom: 0;
    background-color: #fff;
  }
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 5px;
    span {
      font-size: 10px;
      text-transform: capitalize;
    }
  }
  /* the last should always be the profile */
  div:last-child {
    cursor: pointer;
    display: none;
    align-items: center;
    flex-direction: column;
    gap: 5px;

    @media (max-width: 768px) {
      display: flex;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid transparent;
      }
    }

    span {
      font-size: 10px;
      text-transform: capitalize;
    }
  }
`;
